import React, { useEffect } from "react";
import CookieConsent from "@organism/CookieConsent/CookieConsent";

export default ({ children, location }) => {
  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    // #region agent log
    fetch('http://127.0.0.1:7695/ingest/ccc6928c-1fba-41bf-842f-c8b60066ad8a',{method:'POST',headers:{'Content-Type':'application/json','X-Debug-Session-Id':'b88c9e'},body:JSON.stringify({sessionId:'b88c9e',runId:'pre-fix-1',hypothesisId:'H1',location:'src/layouts/index.js:6',message:'Layout mounted',data:{pathname:window.location.pathname,hasLocationProp:Boolean(location),locationPathname:location?.pathname||null},timestamp:Date.now()})}).catch(()=>{});
    // #endregion
  }, [location]);

  return (
    <div>
      {children}
      <CookieConsent />
    </div>
  );
};
